var _path, _path2, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorCashRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.686,13.048h22.628c.96,0,1.739.779,1.739,1.739v7.177H7.947v-7.177c0-.96.779-1.739,1.739-1.739Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.096,24.367l2.137,11.802c.266,1.47-.864,2.823-2.358,2.823H8.126c-1.494,0-2.624-1.353-2.358-2.823l2.137-11.802"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.188,
    y: 3.007,
    width: 8.514,
    height: 4.578,
    rx: 1.163,
    ry: 1.163
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.445,
    y1: 13.048,
    x2: 27.445,
    y2: 7.586
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.425,
    y1: 17.506,
    x2: 24.313,
    y2: 17.506
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.249,
    y1: 26.221,
    x2: 15.819,
    y2: 26.221
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.715,
    y1: 26.221,
    x2: 22.285,
    y2: 26.221
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 26.181,
    y1: 26.221,
    x2: 28.751,
    y2: 26.221
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.665,
    y1: 29.992,
    x2: 15.235,
    y2: 29.992
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 19.715,
    y1: 29.992,
    x2: 22.285,
    y2: 29.992
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 26.765,
    y1: 29.992,
    x2: 29.335,
    y2: 29.992
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 11.925,
    y1: 34.173,
    x2: 14.495,
    y2: 34.173
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 19.715,
    y1: 34.173,
    x2: 22.285,
    y2: 34.173
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 27.505,
    y1: 34.173,
    x2: 30.075,
    y2: 34.173
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCashRegister);
export default __webpack_public_path__ + "static/media/indoor-cash_register.5810d6576e342af1900182a9efc20f58.svg";
export { ForwardRef as ReactComponent };